import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet-async";

export function Contact() {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "/image/bg/astrobg.webp";
    img.onload = () => setImageLoaded(true);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.mobile || !formData.email || !formData.message) {
      alert("Please fill in all fields.");
      return;
    }
    setIsSending(true);
    emailjs
      .send("service_xsw35lr", "template_fqxlrgv", formData, "PdDcz57k9EmLXja-y")
      .then(
        () => {
          setSuccessMessage("Message sent successfully! We will reach out to you soon.");
          setFormData({ name: "", mobile: "", email: "", message: "" });
        },
        (error) => {
          console.log("Email send error:", error);
          alert("Failed to send the message. Please try again later.");
        }
      )
      .finally(() => setIsSending(false));
  };

  return (
    <div
      className="relative min-h-screen flex mt-28 sm:mt-12 items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: imageLoaded ? "url('/image/bg/astrobg.webp')" : "none" }}
    >
      <Helmet>
                    <title>Contact Us || Astro-MahaMaya</title>
                    <meta name="description" content="For connect to the astrologer, contact us at +91 9827504751" />
                    <meta name="keywords" content="contactus, astromahamaya, akhileshwar sharma" />
                    <meta property="og:title" content="Contact Us - AstroMahaMaya" />
                    <meta property="og:description" content="For connect to the astrologer, contact us at +91 9827504751" />
                    <meta property="og:url" content="https://astromahamaya.com/contact" />
                  </Helmet>
      <div className="absolute inset-0 bg-yellow-500 bg-opacity-80"></div>
      <div className="relative z-10 w-full max-w-3xl p-8 bg-yellow-100 bg-opacity-90 rounded-xl shadow-xl border border-yellow-500 mt-20">
        <h1 className="text-4xl font-bold text-center text-black mb-2">📞 Contact Us</h1>
        <p className="text-lg text-gray-800 text-center mb-6">Connect with an astrologer for guidance.</p>
        <form onSubmit={sendEmail} className="space-y-4">
          <div>
            <label className="block text-black">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-3 border border-gray-700 rounded-lg bg-gray-800 opacity-80 text-gray-300 focus:border-yellow-400 outline-none transition-transform transform hover:scale-105"
              placeholder="Enter your name"
              required
            />
          </div>
          <div>
            <label className="block text-black">Mobile No.</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full p-3 border border-gray-700 rounded-lg bg-gray-800 opacity-80 text-gray-300 focus:border-yellow-400 outline-none transition-transform transform hover:scale-105"
              placeholder="Enter your mobile number"
              required
            />
          </div>
          <div>
            <label className="block text-black">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 border border-gray-700 rounded-lg bg-gray-800 opacity-80 text-gray-300 focus:border-yellow-400 outline-none transition-transform transform hover:scale-105"
              placeholder="Enter your email"
              required
            />
          </div>
          <div>
            <label className="block text-black">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="w-full p-3 border border-gray-700 rounded-lg bg-gray-800 opacity-80 text-gray-300 focus:border-yellow-400 outline-none transition-transform transform hover:scale-105"
              placeholder="Enter your message"
              rows="4"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            disabled={isSending}
            className={`w-full text-black font-bold py-3 rounded-lg flex items-center justify-center transition-transform transform hover:scale-105 shadow-lg ${
              isSending ? "bg-gray-500 cursor-not-allowed" : "bg-yellow-600 hover:bg-yellow-500"
            }`}
          >
            {isSending ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                </svg>
                Sending...
              </>
            ) : (
              "Send Message"
            )}
          </button>
          {successMessage && <p className="text-green-400 text-center mt-4">{successMessage}</p>}
        </form>
      </div>
    </div>
  );
}
export default Contact;